import { createApp } from 'vue'
import App from './App.vue'
import ModalLogin from "@/components/ModalLogin.vue";
import router from "@/router"
import store from "@/store"
import { createI18n } from 'vue-i18n';
import {getItem, setItem} from "@/helpers/persistanceStorage";


// Import Bootstrap and BootstrapVue CSS files (order is important)
import Notifications from '@kyvg/vue3-notification'
import VueSweetalert2 from 'vue-sweetalert2';

const styles = (() => {
  import('normalize.css')
  import('sweetalert2/dist/sweetalert2.min.css');
  import('bootstrap/dist/css/bootstrap.min.css');

  import('@/scss/style.scss')
})


function loadLocaleMessages() {
  const locales = require.context('./', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}
const messages = loadLocaleMessages();
var locale = 'uk';
const path = window.location.href.split('?')[0];
if (path.includes('/ru/')) {
  locale = 'ru';
}

let lang = getItem('lang')
if (lang === null){
  setItem('lang', locale)
} else {
  locale = lang
}
console.log(`lang: ${locale}`)

const i18n = createI18n({
  locale: locale,
  fallbackLocale: locale,
  messages: messages,
})

if (document.getElementById('app') && !document.getElementById('appModalLogin')) {
  createApp(App)
      .use(i18n)
      .use(store)
      .use(router)
      .use(styles)
      .use(Notifications)
      .use(VueSweetalert2)
      .mount('#app')
}


if (document.getElementById('appModalLogin')) {
  const appModalLogin = createApp(ModalLogin)
      .use(i18n)
      .use(VueSweetalert2)
      .mount('#appModalLogin')

  window.showModalLogin = function showModalLogin(isContinue=false) {
    if (window.isContinueLoginModalAuth){
      isContinue = true;
    }
    appModalLogin.isShowModal = true;
    appModalLogin.isContinue = isContinue;
  }
  window.showModalLogin();
}
